import {mapState} from "vuex";
import globalNewCar from "@/helpers/globalNewCar";

export default {
    computed: {
        ...mapState({
            lib: state => state.lib
        }),
        daysInSale() {
            if (this.car.deleted == 1) {
                let deleted = 0;
                if (this.car.deleted_at > 0) {
                    deleted = parseInt(this.car.deleted_at) * 1000
                } else {
                    deleted = this.moment(this.car.updated);
                }

                //return this.moment(parseInt(this.car.deleted_at) * 1000).diff(this.moment(this.car.skrdags, "YYYYMMDD"), "days");
                return this.moment(deleted).diff(this.moment(this.car.fyrstiskrdagur, "YYYYMMDD"), "days");
            }
            return this.moment().diff(this.moment(this.car.skrdags, "YYYYMMDD"), "days");
        },
        showSearch() {
            return this.car.deleted == 1 ? false : true;
        },
        titleShowAllBtn() {
            return this.showAllInfo ? '- Fela allan búnað' : '+ Sýna allan búnað';
        },

        fyrstiskrdagur() {
            let text = "";
            this.car &&
            this.car.fyrstiskrdagur &&
            this.car.fyrstiskrdagur.split("").forEach((el, i) => {
                text += el;
                if (i === 3 || i === 5) {
                    text += "-";
                }
            });
            return text;
        },
        accessories() {
            const hasObject = typeof this.car.aukahlutir;
            return hasObject == "object" ? this.car.aukahlutir : {};
        },
        price() {
            return this.car && this.car.verd ? this.car.verd * 1000 : 0;
        },
        getCo2() {
            return this.car.co2;
        },
        isElectroCar() {
            return (
                this.convertCarData.fuelType1 &&
                this.convertCarData.fuelType1.name === "Rafmagn" &&
                !this.convertCarData.fuelType2
            );
        },
        isHybridCar() {
            return (
                this.convertCarData.fuelType1 &&
                this.convertCarData.fuelType1.name === "Rafmagn" &&
                this.convertCarData.fuelType2 &&
                this.convertCarData.fuelType2.name.length
            );
        },
        convertCarsPhoto() {
            return (
                this.car.carsPhotos &&
                this.car.carsPhotos.map(
                    el => globalNewCar.getPicUrl(el.file_name)
                    // el => `${getBaseUrl()}/images/${el.file_name}.webp`
                    // el => `${getBaseUrl()}/img/cars/${el.car_id}/${el.id}.jpg`
                )
            );
        },
        convertCarData() {
            const hasCompany = this.car && this.car.company;

            const transmission =
                this.lib &&
                this.lib.girartegund &&
                this.lib.girartegund.find(
                    item => this.car && item.id == this.car.girartegund
                );

            const fuelType1 =
                this.fuelTypes &&
                this.fuelTypes.find(fuel => fuel.id == this.car.eldsneyti);
            const fuelType2 =
                this.car && this.car.eldsneyti2 && this.fuelTypes
                    ? this.fuelTypes.find(fuel => fuel.id == this.car.eldsneyti2)
                    : null;

            let fuels = `${fuelType1 ? fuelType1.name : ""} ${
                fuelType2 ? ", " + fuelType2.name : ""
            }`;

            if (this.car.fuel3 == 9000) {
                fuels = `${fuelType1 ? fuelType1.name : ""} ${
                    fuelType2 ? " " + fuelType2.name : ""}`

                fuels = fuels.replace("Rafmagn", '');
                fuels += ' Hybrid';
            }

            const basicInfo = [];

            if (this.car && this.car.skrmanudur && this.car.argerd) {
                basicInfo.push({
                    key: "Nýskráning",
                    value: `${this.car.skrmanudur}/${this.car.argerd}`
                });
            }
            if (this.car && this.car.transmission && this.car.girar && this.car.girar != "0") {
                basicInfo.push({
                    key: "",
                    value: transmission.name
                        ? `${transmission.name} ${this.car.girar} rirar`
                        : ""
                });
            }
            if (this.car && this.car.ext_ekinnkm && this.car.ext_ekinnkm != "0") {
                const value = +this.car.ext_ekinnkm
                basicInfo.push({
                    key: "Akstur",
                    value: value.format() + " km"
                });
            }
            if (fuels) {
                basicInfo.push({
                    key: "Eldsneyti",
                    value: fuels
                });
            }
            // if (this.car.fyrstiskrdagur) {
            //     basicInfo.push({
            //         key: 'Nýskráning',
            //         value: this.moment(this.car.fyrstiskrdagur, 'YYYYMMDD').format("YYYY")
            //     })
            // }

            if (this.car.batterykw > 0) {
                basicInfo.push({
                    key: 'Stærð rafhlöðu',
                    value: this.car.batterykw + ' kWh'
                })
            }


            if (this.car.batterykm > 0) {
                basicInfo.push({
                    key: 'Drægni',
                    value: this.car.batterykm + ' km'
                })
            }


            if (this.car.naestaskodun) {
                basicInfo.push({
                    key: 'Næsta skoðun',
                    value: this.car.naestaskodun
                })
            }

            if (this.car.hestofl) {
                basicInfo.push({
                    key: 'Hestöfl',
                    value: this.car.hestofl
                })
            }

            if (this.car.argerd) {
                basicInfo.push({
                    key: '',
                    value: this.girartegundName//this.car.girartegund
                })
            }

            if (this.car.drif) {
                basicInfo.push({
                    key: '',
                    value: this.drifName
                })
            }


            if (this.car.slagrymi > 0) {
                basicInfo.push({
                    key: 'Vélastærð',
                    value: (parseInt(this.car.slagrymi).format('0,0')) + ' cc.'
                })
            }

            if (this.car.litur) {
                basicInfo.push({
                    key: 'Litur',
                    value: this.colorName
                })
            }

            if (this.car.dyr) {
                basicInfo.push({
                    key: 'Dyrafjöldi',
                    value: this.car.dyr
                })
            }

            if (this.car.manna) {
                basicInfo.push({
                    key: 'Sætafjöldi',
                    value: this.car.manna
                })
            }


            if (this.car.skrdags) {
                basicInfo.push({
                    key: 'Skráð í söluskrá',
                    value: this.moment(this.car.skrdags, 'YYYYMMDD').format("DD.MM.YYYY")
                })
            }


            if (this.car.co2 > 0) {
                basicInfo.push({
                    key: 'CO2',
                    value: this.car.co2 + ' g/km'
                })
            }

            if (this.car.how_long_car_will_go_value == 3 || this.car.how_long_car_will_go_value == 1) {
                basicInfo.push({
                    key: 'Staðsett',
                    value: 'Erlendis'
                })
            }

            if (this.car.how_long_car_will_go_value == 3) {
                basicInfo.push({
                    key: 'Afhendingartími',
                    value: this.car.how_long_car_will_go + ' vikur'
                })
            }

            if (this.car.how_long_car_will_go_value == 1) {
                basicInfo.push({
                    key: 'Afhendingartími',
                    value: this.moment(this.car.date_arrives_in_iceland, 'YYYYMMDD').format("DD.MM.YYYY")
                })
            }


            let logoBrand = this.car.brand && this.car.brand.logo


            const hasPrice = this.car && this.car.verd > 0 ? this.car.verd : 0;
            let hasOldPrice = this.car && this.car.old_price;
            if (typeof (hasOldPrice) === "string") {
                hasOldPrice = parseInt(hasOldPrice);
            }

            const parkingAddress = this.car && this.car.spot > 0 && this.car.stadsetning;

            return {
                id: this.car && this.car.id,
                brand: this.car && this.car.ext_modframleidandi,
                model: this.car && this.car.ext_modgerd,
                logoBrand: logoBrand,
                mileage: this.car && this.car.ekinn,
                price: hasOldPrice ? (hasOldPrice * 1000) : (hasPrice ? this.car.verd * 1000 : 0),
                oldPrice: hasOldPrice ? hasPrice * 1000 : 0,
                basicInfo,
                company: {
                    id: hasCompany && hasCompany.id,
                    logo: `${hasCompany && hasCompany.logo}`,
                    phone: hasCompany && hasCompany.phone,
                    site: hasCompany && hasCompany.site,
                    // logo: `/img/logos/${hasCompany && hasCompany.logo}`,
                    name: hasCompany && hasCompany.name,
                    address: hasCompany && hasCompany.location,
                    total_cars: hasCompany && hasCompany.total_cars,
                },
                parkingAddress: parkingAddress ? parkingAddress : '',
                retailDescription: this.car && this.car.verdtilbod == 1 && this.car.verdath,
                spot: this.car && this.car.spot && this.car.spot != null,
                fuelType1,
                fuelType2,
                thumbnail: this.convertCarsPhoto.length && this.convertCarsPhoto[0],
                deleted: this.car.deleted,
                apiId: this.car.api_id || null,
                is_price_changing: this.car.is_price_changing > 0 ? parseInt(this.car.is_price_changing) : 0,
                is_special_price: this.car.is_special_price > 0 ? parseInt(this.car.is_special_price) : 0,
                withoutVat: this.car.anvsk == 1 || false,
                exchangeForCheaper: this.car.skiptiodyrari,
                exchangeForExpensive: this.car.skiptidyrari,
            };
        },
        showCalculator() {
            let showCalculator = this.car.flokkur_id == 7 ? false : true;
            return showCalculator
        },
        convertSimilarCarsData() {
            const addProp = {isSlider: true, ad: true, ...this.ad};
            let cars = this.cars && this.cars.map(car => this.convertCar(car));
            cars.unshift(addProp)

            return cars;
            /*
            return (
                this.cars &&
                this.cars.map(car => ({
                    id: car.car_id,
                    brand: car.b,
                    model_class: car.m,
                    thumbnail: car.main_img
                        ? globalNewCar.getPicUrl(car.main_img)
                        // ? `${getBaseUrl()}/images/${car.main_img}.webp`
                        : `${getBaseUrl()}/img/main-thumb.png`,
                    price: car.v + "000",
                    price_hide: "0",
                    transmision_id: car.g,
                    isOldCars: true
                }))
            );

             */
        },
        getOgTitle() {
            let title = '';
            if (this.car) {
                const convertCar = this.convertCarData;
                const car = this.car;
                title = `${car.ext_modframleidandi ? car.ext_modframleidandi.toUpperCase() : ''} ${car.ext_modgerd ? car.ext_modgerd.toUpperCase() : ''}`;
                title += ` | ${car.argerd || ''}`;
                if (car.ekinn) {
                    title += ` | Akstur ${parseInt(car.ext_ekinnkm).format()} km.`;
                }

                if (convertCar.price) {
                    title += ` | ${parseInt(convertCar.oldPrice ? convertCar.oldPrice : convertCar.price).format()} kr.`;
                }
                return title;
            }
        },
        getMateData() {
            if (this.car && this.car.meta) {
                return this.car.meta;
            } else {
                return {
                    image: '/img/share2.png?33',
                    width: 0,
                    height: 0
                }
            }
            //return this.car && this.car.meta;
        },
        getMeta() {
            const meta = this.getMateData;
            let image = '??';
            if (this.car) {
                image = meta && meta.image ? meta.image + "?" + (new Date().getTime()) : '/img/share2.png?22';

                console.log("META Image",image);
            }
            let res = [
                {name: 'og:title', content: this.getOgTitle},
                {
                    name: 'og:description',
                    content: 'Bílaskrá.is - Fyrsta bílasöluappið á Íslandi! Verðvakt lætur þig vita ef verðið á draumabílnum lækkar.'
                },
                {name: 'og:image', content: image},
                {name: 'og:image:width', content: meta.width},
                {name: 'og:image:height', content: meta.height}
            ];

            if ((this.car && this.car.deleted == 1) || this.isK7) {
                res.push({name: 'robots', content: 'noindex'});
            }
            return res;
        },
        getTitle() {
            if (this.car) {
                return ((this.car.ext_modframleidandi || '') + " " + (this.car.ext_modgerd || ""));
            } else {
                return "bilaskra.is";
            }
        },
        destroy() {
            this.$store.state.moduleOldCars.carLoaded = false;
        },
        isK7() {
            return this.$route.name === 'k7Car'
        },
    }
}